import { render, staticRenderFns } from "./pet-policy-detail-info.vue?vue&type=template&id=0f11de3f&scoped=true&"
import script from "./pet-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./pet-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./pet-policy-detail-info.vue?vue&type=style&index=0&id=0f11de3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f11de3f",
  null
  
)

export default component.exports